import { Shield } from "lucide-react";
import { estimateInsuranceMonthly } from "../lib/insuranceEstimate";

/**
 * Phase 4.22 — Mini-Versicherungs-Badge auf ListingCards.
 * Zeigt deterministisch berechnete monatliche Haftpflicht-Annäherung.
 * Wird nur gerendert, wenn die Berechnung möglich ist.
 */
export default function MiniInsuranceBadge({ listing, className = "" }) {
    const monthly = estimateInsuranceMonthly(listing);
    if (monthly == null) return null;
    return (
        <span
            className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-bold px-1.5 py-0.5 bg-blue-50 text-blue-800 border border-blue-200 rounded-sm ${className}`}
            title="Geschätzte Haftpflicht-Versicherung (SF1/2). Klick auf das Inserat zeigt die volle Kalkulation."
            data-testid="mini-insurance-badge"
        >
            <Shield className="w-2.5 h-2.5" />
            ab {monthly}€/Mon. versichert
        </span>
    );
}
